module.exports = __webpack_public_path__ + "img/frost_claws_small.c224671d.png";